'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable');
const { trackEvent } = require('../start/ga-consent');

module.exports = function SubscriptionAddInsModel(taskBuilder, subscriptionModel) {
	const obj = observable(this),
		loadAddIns = async () => {
			obj.dispatchEvent('loadingAddIns');
			try {
				const taskId = taskBuilder.newTaskId(),
					currentTask = await taskBuilder.build(taskId);
				await currentTask.execAndWaitFor('stripe/add_ins/list', {}, (taskMetadata) => taskMetadata && taskMetadata.addIns);
				obj.dispatchEvent('loadedAddIns', currentTask.metadata.addIns);
				return currentTask.metadata.addIns;
			} catch (e) {
				obj.dispatchEvent('error', e);
				throw e;
			}
		};

	obj.loadAddIns = loadAddIns;

	obj.requestPreview = async (addInId, quantity) => {
		if (!addInId || !Number.isFinite(quantity) || quantity < 1) {
			throw new Error('invalid-args');
		}
		obj.dispatchEvent('loadingAddInPreview');
		try {
			const taskId = taskBuilder.newTaskId(),
				currentTask = await taskBuilder.build(taskId);
			await currentTask.execAndWaitFor('stripe/add_ins/preview', {addInId, quantity}, (taskMetadata) => taskMetadata && taskMetadata.preview);
			obj.dispatchEvent('loadedAddInPreview', {addInId, quantity, preview: currentTask.metadata.preview});
			return currentTask.metadata.preview;
		} catch (e) {
			obj.dispatchEvent('error', e);
			throw e;
		}

	};
	obj.purchase = async (addInId, quantity) => {
		if (!addInId || !Number.isFinite(quantity) || quantity < 1) {
			throw new Error('invalid-args');
		}
		try {
			obj.dispatchEvent('purchaseInProgress');
			const taskId = taskBuilder.newTaskId(),
				currentTask = await taskBuilder.build(taskId),
				waitForTaskCompletion = (taskMetadata) => {
					if (!taskMetadata.status) {
						return false;
					}
					if (taskMetadata.status === 'actionRequired') {
						obj.dispatchEvent('purchaseAuthUrl', taskMetadata.actionUrl);
					}
					obj.dispatchEvent('purchaseStatus', taskMetadata.status);
					return ['cancelled', 'chargeSucceeded', 'chargeFailed'].includes(taskMetadata.status);
				};
			await currentTask.execAndWaitFor('stripe/add_ins/purchase', {addInId, quantity}, waitForTaskCompletion);
			if (currentTask.metadata.status === 'chargeSucceeded') {
				loadAddIns();
				
				trackEvent({
					action: 'add_in_purchase_completed',
					addin_id: addInId,
					quantity: quantity
				});

				subscriptionModel.getGoldAccountDetails(true, false);
			}
			return currentTask;
		} catch (e) {
			obj.dispatchEvent('error', e);
			throw e;
		}

	};

	obj.remove = async (addInId) => {
		try {
			obj.dispatchEvent('removalInProgress');
			const taskId = taskBuilder.newTaskId(),
				currentTask = await taskBuilder.build(taskId);
			await currentTask.execAndWaitFor('stripe/add_ins/remove', {addInId}, (taskMetadata) => taskMetadata && taskMetadata.status);
			obj.dispatchEvent('removalStatus', currentTask.metadata.status);
			if (currentTask.metadata.status === 'removalSucceeded') {
				await loadAddIns();
				
				trackEvent({
					action: 'add_in_purchase_removed',
					addin_id: addInId,
				});

				await subscriptionModel.getGoldAccountDetails(true, false);
			}
			return currentTask;
		} catch (e) {
			obj.dispatchEvent('error', e);
			throw e;
		}

	};
	obj.restore = async (addInId) => {
		try {
			obj.dispatchEvent('restoreInProgress');
			const taskId = taskBuilder.newTaskId(),
				currentTask = await taskBuilder.build(taskId);
			await currentTask.execAndWaitFor('stripe/add_ins/restore', {addInId}, (taskMetadata) => taskMetadata && taskMetadata.status);
			obj.dispatchEvent('restoreStatus', currentTask.metadata.status);
			if (currentTask.metadata.status === 'restoreSucceeded') {
				await loadAddIns();

				trackEvent({
					action: 'add_in_purchase_restored',
					addin_id: addInId,
				});

				await subscriptionModel.getGoldAccountDetails(true, false);
			}
			return currentTask;
		} catch (e) {
			obj.dispatchEvent('error', e);
			throw e;
		}

	};

};
